module.exports = __webpack_public_path__ + "img/4.65a71ebc.png";